

angular
.module('inkfinder')
.factory('CheckUsername', function CheckUsername(
  Collector,
  Shop,
  Session,
  $q,
  _,
  RESERVED_ROUTES
) {
  // Public methods
  CheckUsername.check = check;

  /**
   * @name check
   * @description Function to check if the username is available
   * @param {string} username The username to check
   * @param {string} currentUsername The existing username to check against
   * @return {object} Returns an object with the usernames array and status
   */
  function check(username, currentUsername) {
    let results = {};
    results.usernameValid = false;
    results.usernameCheckMessage = null;
    if (username && username.match(/^[a-z0-9]*$/)) {
      return $q.all([
        Collector.getCollectors(username),
        Shop.getShops(username)
      ]).then(function(usernames) {
        results.usernames = _.merge(usernames[0], usernames[1]);
        if (results.usernames.length === 0 &&
        checkReservedNames(username) !== true) {
          results.usernameValid = true;
          results.usernameCheckMessage = 'Available!';
        } else if (results.usernames.length > 0 &&
        results.usernames[0].username === currentUsername) {
          results.usernameValid = true;
          results.usernameCheckMessage = 'That’s you!';
        } else {
          results.usernameValid = false;
          results.usernameCheckMessage = 'Not available';
        }
        return results;
      });
    }
    return $q(function(resolve, reject) {
      resolve(results);
    });
  }

  /**
   * @name checkReservedNames
   * @description Function to check a constant of reserved names.
   * @param {string} username The name to check against
   * @return {boolean} Returns a boolean
   */
  function checkReservedNames(username) {
    // return _.each(RESERVED_ROUTES, function(route) {
    //   if (route === username) {
    //     return true;
    //   }
    // });
    let value = _.some(RESERVED_ROUTES, function(route) {
      return route === username;
    });
    return value;
  }
  return CheckUsername;
});



// WEBPACK FOOTER //
// ./components/collector/util/check-username.service.js